<!--
 * @FileDescription: 单据——组装拆卸单详情
 * @Author: ryb
 * @Date: 2020-07-22
 -->
<template>
  <div class="bill-purchase-page">
    <div class="bill-purchase-information" id="page-top">
        <a-row class="ant-row-one">
            <a-row style="width: 50%">
                <a-col v-if="formData.reverseFlag == 0 && formData.state == '4'">
                    <span class="a-col-title">红冲原因：</span>
                    <span class="a-col-value"> {{formData.reverseReason}}</span>
                </a-col>
            </a-row>
            <a-row :span="12" style="width: 50%;display:flex;justify-content: flex-end;">
                <a-col>
                    <span class="a-col-title">付款单号：</span>
                    <span class="a-col-value"> {{formData.combindCode}}</span>
                </a-col>
                <a-col style="margin-left: 106px">
                    <span class="a-col-title">单据日期：</span>
                    <span class="a-col-value">{{formData.combindDate}}</span>
                </a-col>
            </a-row>
        </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">调出仓库：</span>
          <span class="a-col-value"> {{formData.outboundStorageName}}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">调入仓库：</span>
          <span class="a-col-value">  {{formData.inboundStorageName}}</span>
        </a-col>
          <a-col v-if="formData.transactorName">
              <span class="a-col-title">经办人：</span>
              <span class="a-col-value">{{formData.transactorName}}</span>
          </a-col>
          <a-col style="display: flex;align-items: center;justify-content: center" v-if="formData.digest">
              <span class="a-col-title">摘要：</span>
              <a-tooltip>
                  <template slot="title">
                      {{formData.digest}}
                  </template>
                  <span class="a-col-value1">{{formData.digest}}</span>
              </a-tooltip>
          </a-col>
          <a-col style="display: flex;align-items: center;justify-content: center" v-if="formData.remark">
              <span class="a-col-title">备注：</span>
              <a-tooltip>
                  <template slot="title">
                      {{formData.remark}}
                  </template>
                  <span class="a-col-value1">{{formData.remark}}</span>
              </a-tooltip>
          </a-col>
      </a-row>
    </div>
      <div class="line"></div>
    <div class="bill-purchase-table">
          <div class="bill-table-title">组装/拆卸前</div>
          <a-table :columns="columns" :dataSource="dataSource" :scroll="{ x:1000 }" :pagination="false" rowKey="id"  bordered>
            <template slot="name" slot-scope="text, record, index">
                <img v-if="record.assemblyFlag == 1" src="@/assets/image/manage_zong@2x.png" style="width: 22px;margin-right: 4px"/>
                <a-tooltip>
                    <template slot="title">
                        {{text}}
                    </template>
                    <span>{{ text }}</span>
                </a-tooltip>
            </template>
            <template slot="footer">
              <!--<a-table :columns="columns" :dataSource="footerDataSource" class="table-footer-detail" :pagination="false" :showHeader="false" rowKey="id" bordered></a-table>-->
                <div class="footer-total-amount">
                    <div class="footer-total-amount-left" style="width: 80px">
                        <span class="title">小计</span>
                    </div>
                    <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                        <span class="right-col">出库数量：{{ footerDataSource[0].needCount }}</span>
                        <span class="right-col">金额：{{ footerDataSource[0].totalAmount }}</span>
                    </div>
                </div>
            </template>
          </a-table>
    </div>
      <div class="line"></div>
      <div class="bill-purchase-table" >
          <div class="bill-table-title">组装/拆卸后</div>
          <a-table :columns="columns" :dataSource="dataSource1" :pagination="false" :scroll="{ x:1000 }" rowKey="id"  bordered>
              <template slot="name" slot-scope="text, record, index">
                  <img v-if="record.assemblyFlag == 1" src="@/assets/image/manage_zong@2x.png" style="width: 22px;margin-right: 4px"/><span>{{ text }}</span>
              </template>
              <template slot="footer" slot-scope="currentPageData">
                  <!--<a-table :columns="columns1" :dataSource="footerDataSource1" class="table-footer-detail" :pagination="false" :showHeader="false" rowKey="id" bordered></a-table>-->
                  <div class="footer-total-amount">
                      <div class="footer-total-amount-left" style="width: 80px">
                          <span class="title">小计</span>
                      </div>
                      <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                          <span class="right-col">入库数量：{{ footerDataSource[0].needCount }}</span>
                          <span class="right-col">金额：{{ footerDataSource[0].totalAmount }}</span>
                      </div>
                  </div>
              </template>
          </a-table>
      </div>


    <public-footer :buttonList="buttonList" @onClickButton="onClickButton" @onConfirmRedDash="onConfirmRedDash" @confirmDeletion="onDeleteOrder" @btnOkSave="btnOkSave" @onConfirmOrder="onConfirmOrder"></public-footer>
    <preserve-modal ref="preserve"></preserve-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import publicFooter from '@/components/module/publicFooter.vue'
import preserveModal from '@/components/module/preserveModal.vue'
import {combindId,locationSkuList,combindflush} from "@/utils/api";
import { orderList } from "../methhod/orderList"
export default {
  name: 'assemblyDetail',
    mixins: [orderList],
  components: {
    publicFooter,
    preserveModal
  },
  data () {
    return {
        columns: [
            {
                title: '',
                width: 60,
                align: 'center',
                dataIndex: 'rowIndex',
                customRender: function (text, r, index) {
                    return (text !== '合计') ? (parseInt(index) + 1) : text
                }
            },
            {
                title: '商品名称',
                dataIndex: 'productName',
                key:'productName',
                ellipsis: true,
                width: 180,
                scopedSlots: { customRender: 'name' }
            },
            {
                title: '商品编号',
                ellipsis: true,
                width: 180,
                dataIndex: 'productCode',
                key:'productCode',
            },
            {
                title: '规格',
                ellipsis: true,
                dataIndex: 'productSpecification',
                key:'productSpecification'
            },
            {
                title: '型号',
                ellipsis: true,
                dataIndex: 'productModel',
                key:'productModel'
            },
            {
                title: '单位',
                ellipsis: true,
                dataIndex: 'productUnit',
                key:'productUnit'
            },
            {
                title: '出库数量',
                ellipsis: true,
                align: "right",
                dataIndex: 'needCount',
                key:'needCount',
                scopedSlots: { customRender: 'num' }
            },
          {
            title: '单价',
            ellipsis: true,
            align:'right',
            dataIndex: 'costPrice',
            key:'costPrice'
          },
          {
            title: '金额',
            ellipsis: true,
            align:'right',
            dataIndex: 'totalAmount',
            key:'totalAmount'
          },
            {
                title: '出库库位',
                width:180,
                dataIndex: 'locationName',
                key:'locationName',
                scopedSlots: { customRender: 'location' }
            },
        ],
        columns1: [
            {
                title: '',
                width: 60,
                align: 'center',
                dataIndex: 'rowIndex',
                customRender: function (text, r, index) {
                    return (text !== '合计') ? (parseInt(index) + 1) : text
                }
            },
            {
                title: '商品名称',
                dataIndex: 'productName',
                key:'productName',
                width: 180,
                scopedSlots: { customRender: 'name' }
            },
            {
                title: '商品编号',
                ellipsis: true,
                width: 180,
                dataIndex: 'productCode',
                key:'productCode',
            },
            {
                title: '规格',
                ellipsis: true,
                dataIndex: 'productSpecification',
                key:'productSpecification'
            },
            {
                title: '型号',
                ellipsis: true,
                dataIndex: 'productModel',
                key:'productModel'
            },
            {
                title: '单位',
                ellipsis: true,
                dataIndex: 'productUnit',
                key:'productUnit'
            },
            {
                title: '入库数量',
                ellipsis: true,
                align: "right",
                dataIndex: 'needCount',
                key:'needCount',
                scopedSlots: { customRender: 'num' }
            },
          {
            title: '单价',
            ellipsis: true,
            align:'right',
            dataIndex: 'costPrice',
            key:'costPrice'
          },
          {
            title: '金额',
            ellipsis: true,
            align:'right',
            dataIndex: 'totalAmount',
            key:'totalAmount'
          },
            {
                title: '入库库位',
                width:180,
                dataIndex: 'locationName',
                key:'locationName',
                scopedSlots: { customRender: 'location' }
            },
        ],
      dataSource: [],
      dataSource1: [],
      footerDataSource: [],
      footerDataSource1: [],
      tableHeight: '',
      formData:{
          combindCode:'',
          combindDate:'',
          outboundStorageName:'',
          inboundStorageName:'',
          transactorName:'',
          digest:'',
          remark:'',
          reverseReason:'',
          reverseFlag:'',
          state:'',
      },
    }
  },
    beforeRouteUpdate(to,from,next){
        this.detailId = to.query.id
        this.queryObj = to.query
        this.getList()
        this.getInit(6)
        next()
    },
    activated(){
        this.detailId = this.$route.query.id
        this.queryObj = this.$route.query
        this.getList()
        this.getInit(6)
    },
  mounted () {
    // 表格高度计算
    let pageHeight = document.getElementById('content').offsetHeight
    let makeTop = document.getElementById('page-top').offsetHeight
    this.tableHeight = (pageHeight - makeTop  - 200)/2
  },
  methods: {
    /** 表格增加合计行 */
    tableAddTotalRow (columns, dataSource) {
        this.footerDataSource = []
        let numKey = 'rowIndex'
        let totalRow = { [numKey]: '合计' }
        columns.forEach(column => {
            let { key, dataIndex } = column
            if (dataIndex == 'needCount' || dataIndex == 'totalAmount') {
                let total = 0
                dataSource.forEach(data => {
                    if(!this.isEmpty(data.productName)){
                        total = total +  Number.parseFloat(data[dataIndex])
                    }
                })
                totalRow[dataIndex] = total
            }
        })
        this.footerDataSource.push(totalRow)
    },
      tableAddTotalRow1 (columns, dataSource) {
          this.footerDataSource1 = []
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          columns.forEach(column => {
              let { key, dataIndex } = column
              if (dataIndex == 'needCount' || dataIndex == 'totalAmount') {
                  let total = 0
                  dataSource.forEach(data => {
                      if(!this.isEmpty(data.productName)){
                          total = total +  Number.parseFloat(data[dataIndex])
                      }
                  })
                  totalRow[dataIndex] = total
              }
          })
          this.footerDataSource1.push(totalRow)
      },
      getList(){
          this.$store.state.isLoding = true
          this.dataSource = []
          this.dataSource1 = []
          combindId({},{},{
              id:this.detailId,
              companyStoreId:this.$store.state.shopId,
          }).then((res)=>{
              if(res.success){
                  this.formData.outboundStorageName = res.result.outboundStorageName
                  this.formData.inboundStorageName = res.result.inboundStorageName
                  this.formData.remark = res.result.remark
                  this.formData.digest = res.result.digest
                  this.formData.transactorName = res.result.transactorName
                  this.formData.contactCustomerName = res.result.contactCustomerName
                  this.formData.combindCode = res.result.combindCode
                  this.formData.combindDate = res.result.combindDate
                  this.formData.reverseReason = res.result.reverseReason
                  this.formData.reverseFlag = res.result.reverseFlag
                  this.formData.state = res.result.state
                  res.result.itemList.forEach((item)=>{
                      if(item.behaviorObjType == '1'){
                          this.dataSource.push(item)
                      }else if(item.behaviorObjType == '2'){
                          this.dataSource1.push(item)
                      }
                  })
                  this.tableAddTotalRow(this.columns, this.dataSource)
                  this.tableAddTotalRow1(this.columns1, this.dataSource1)
                  this.$store.state.isLoding = false
              }
          })
      },
      confirmDeletion(){
        this.onDeleteOrder({
            type:'10',
            voucherEntityId:this.detailId
        })
      },
    // 取消退出
      onClickButton (item) {
          this.itemOrder = item
      },
      onConfirmRedDash(value){
          combindflush({},{},{
              companyStoreId:this.$store.state.shopId,
              reverseReason:value,
              id:this.detailId
          }).then((res)=>{
              if(res.success){
                  this.$store.state.closePath = this.$route.fullPath
                  this.$message.success('红冲成功')
              }else{
                  this.$message.warn(res.logMessage)
              }
          })
      },
      onConfirmOrder(value){
          this.onConfirmOrderObj({
              voucherEntityId:this.queryObj.order,
              value:value,
              type:'10',
              code:this.formData.combindCode
          })
      },
      
  }
}
</script>

<style lang="scss">
.bill-purchase-page {
    height: calc(100vh - 200px);
    background: #fff;
  .bill-purchase-information {
    padding: 15px 40px;
    background-color: #ffffff;
    .ant-row-one {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
    .ant-row-two {
      padding: 8px 0;
      display: flex;
      flex-wrap: wrap;
      .ant-col {
        padding-right: 80px;
      }
    }
  }
    .bill-table-title{
        color: #333;
        font-weight: 700;
        font-size: 20px;
        padding: 18px 0 12px 22px;
    }
  .bill-purchase-table {
      height: calc((100vh - 360px)/2);
      .ant-table-body{
          max-height: calc((100vh - 400px)/2 - 100px);
      }
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
  .bill-purchase-price {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 0 40px;
    margin-top: 16px;
    .logistics-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ant-row {
        display: flex;
      }
    }
    .price-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ant-row {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .ant-col {
          margin-left: 42px;
        }
        .price-color {
          font-size: 16px;
          color: #f76f14;
          font-weight: bold;
        }
      }
    }
  }
}
.a-popover-select-user {
  padding-bottom: 12px;

  .ant-table-wrapper {
    padding: 16px 0 12px 0 !important;
  }
  .total-money {
    display: flex;
    justify-content: space-between;
  }
  .ant-table-tbody tr:nth-child(2n) {
    background-color: #ffffff;
  }
}
</style>
